import React, { useEffect, useRef, useState } from "react";
import Input from "../../common/Input";
import Button from "../../common/Button";
import { useDispatch, useSelector } from "react-redux";
import { FieldArray, Form, Formik } from "formik";
import {
  addDrugs,
  addProduct,
  fetchDrugList,
  fetchProducts,
  getAllProducts,
  modifyProduct,
  removeProduct,
  searchDrugList,
  fetchManufacturers,
} from "../../../redux/Thunk/Product/ProductThunks";
import {
  setSearchProducts,
  setSearchStore,
} from "../../../redux/Reducer/Product/ProductSlice";
import { setActiveTab } from "../../../redux/Reducer/Admin/PartnerSlice";
import toast from "react-hot-toast";
import {
  createProductValidation,
  updateProductValidation,
} from "../../common/Validation/createOrderValidation";
import Delete from "../../common/icons/Delete";
import Plus from "../../common/icons/Plus";
import PlusCircle from "../../common/icons/PlusCircle";
import Loader from "../../Loader";
import { debounce } from "lodash";
import { useOutsideClick } from "../../common/useOutsideClick";
import { getLookupMargins } from "../../../redux/Thunk/LookupMargin/MarginThunk";
import SearchSelectProduct from "./SearchSelectedProduct";
import { fetchStores } from "../../../redux/Thunk/Store/StoreThunks";
import ProductTagsSelector from "./ProductTagsSelector";
import ProductTypeSelector from "./ProductTypeSelector";
import ProductStoreSelector from "./ProductStoreSelector";
import ProductVTableSelector from "./ProductVTableSelector";
import ManufacturerSelector from "./ManufacturerSelector";
import apiAxios from "../../../services/apiAxios";
import ProductImageGallery from "../../common/ProductImageGallery";
import ProductImageUploader from "../../common/ProductImageUploader";

function Products() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedDrugs, setSelectedDrugs] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [assignedDrugTags, setAssignedDrugTags] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [newDrug, setNewDrug] = useState("");
  const searchedProduct = useSelector((state) => state?.product?.searchProduct);
  const stores = useSelector((state) => state?.store?.stores);
  const { lookupMargins } = useSelector((state) => state.lookup);
  const { loading, drugList } = useSelector((state) => state.product);

  const [drugs, setDrugs] = useState([]);
  const [removeStockFlags, setRemoveStockFlags] = useState({});
  const [moreStockFlags, setMoreStockFlags] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading] = useState(false);
  const [editingField, setEditingField] = useState(null); // Tracks the field being edited
  const [showEditIcon, setShowEditIcon] = useState(false); // Tracks whether to show the edit icon
  const [marginPercentage, setMarginPercentage] = useState({});
  const [selectedProduct, setSelectedProduct] = useState("");
  const [showNewDrugInput, setShowNewDrugInput] = useState(false);
  const [, setIsRemoveAdminStockEntered] = useState(false);
  const [, setIsMoreStockEntered] = useState(false);
  const [page] = useState(1);
  const role = useSelector((state) => state?.auth?.role);

  const dispatch = useDispatch();
  // const containerRef = useRef(null);
  const loaderRef = useRef(null);
  const productDetails = searchedProduct[0];

  const storeQtyData = productDetails?.storeProducts?.map((store) => ({
    storeId: store?.SID || "",
    stock: store?.storeStock || 0,
    moreQty: "",
  }));

  const initialValues = {
    productId: productDetails?.IID || "",
    productName: productDetails?.productName || "",
    manufacturer: productDetails?.manufacturer || "",
    units: productDetails?.productStock
      ? Number(productDetails?.productStock)
      : 0 || 0,
    moreUnits: 0,
    removeUnits: 0,
    productStock: productDetails?.productStock || 0,
    uom: productDetails?.uom || 0,
    type: productDetails?.type || "",
    drugs: productDetails?.drugs || [],
    tags: productDetails?.tags || [],
    images: Array.isArray(productDetails?.images) ? productDetails.images : [],
    storeQty:
      searchedProduct?.length > 0 && storeQtyData?.length > 0
        ? storeQtyData
        : [{ storeId: "", Qty: 0 }],
    vId: productDetails?.vId || "",

    pricing: {
      mrp: productDetails?.pricing?.mrp || "",
      gst: productDetails?.pricing?.gst || "",
    },
  };
  const inputRef = useRef(null);
  useEffect(() => {
    dispatch(fetchDrugList(page));
    const current_page = 1;
    dispatch(
      getAllProducts({
        current_page,
        SID: "",
        PID: "",
      })
    );
  }, [dispatch, page]);

  useEffect(() => {
    dispatch(getLookupMargins());
    dispatch(fetchStores());
    dispatch(fetchManufacturers());
  }, [dispatch]);

  const handleClickOutside = (event) => {
    // Ensure the dropDownRef and event are valid before accessing properties
    if (
      dropDownRef?.current &&
      !dropDownRef?.current?.contains(event?.target) &&
      !event?.target?.closest("[data-ignore-outside-click]")
    ) {
      setSearchTerm("");
      setIsDropdownOpen(false);
    }
  };
  const dropDownRef = useOutsideClick(handleClickOutside);
  useEffect(() => {
    if (showNewDrugInput && inputRef?.current) {
      inputRef?.current?.focus();
    }
  }, [showNewDrugInput]);

  useEffect(() => {
    if (searchedProduct[0]?.drugs?.length > 0) {
      setSelectedDrugs(
        Array.isArray(productDetails?.drugs)
          ? productDetails.drugs.map((d) => (typeof d === "string" ? d.trim() : d?.name || d?.drugName || "").trim()).filter(Boolean)
          : []
      );
    } else {
      setSelectedDrugs([]);
    }
    if (productDetails?.tags?.length > 0) {
      setSelectedTags(productDetails.tags);
    } else {
      setSelectedTags([]);
    }
    if (productDetails?.drugTags?.length > 0) {
      setAssignedDrugTags(productDetails.drugTags);
    } else {
      setAssignedDrugTags([]);
    }
    if (productDetails?.images?.length > 0) {
      setSelectedImages(Array.isArray(productDetails.images) ? productDetails.images : []);
    } else {
      setSelectedImages([]);
    }
    setEditingField(null);
    setRemoveStockFlags({});
    setMoreStockFlags({});
    setShowEditIcon(false);
    setIsDropdownOpen(false);
  }, [searchedProduct, productDetails?.drugs, productDetails?.tags, productDetails?.drugTags, productDetails?.images]);

  useEffect(() => {
    if (!selectedDrugs || selectedDrugs.length === 0) {
      setAssignedDrugTags([]);
      return;
    }

    let isMounted = true;
    apiAxios
      .post("/api/product/drug/tags-by-names", { drugNames: selectedDrugs })
      .then((res) => {
        if (isMounted && res?.data?.drugTags) {
          setAssignedDrugTags(res.data.drugTags);
        }
      })
      .catch((err) => {
        console.error("Error loading drug tags:", err);
      });

    return () => {
      isMounted = false;
    };
  }, [selectedDrugs]);

  useEffect(() => {
    const debouncedSearch = debounce(() => {
      dispatch(searchDrugList({ searchTerm, selectedDrugs }));
    }, 500);

    debouncedSearch();

    return () => {
      debouncedSearch.cancel();
    };
  }, [searchTerm, selectedDrugs, dispatch]);

  useEffect(() => {
    if (drugList) {
      const uniqueDrugs = drugList.filter(
        (drug, index, self) =>
          drug?.drugName &&
          index ===
          self.findIndex(
            (d) =>
              d?.drugName?.trim().toLowerCase() ===
              drug?.drugName?.trim().toLowerCase()
          )
      );

      // Sort the filtered list in alphabetical order by drugName
      const sortedDrugs = uniqueDrugs.sort((a, b) =>
        (a?.drugName || "").localeCompare(b?.drugName || "", undefined, { sensitivity: "base" })
      );

      setDrugs(sortedDrugs);
      dispatch(setSearchStore(""));
    }
  }, [drugList, dispatch]);

  const handleSelectMargin = React.useCallback((eventValue) => {
    if (!eventValue) {
      setMarginPercentage({});
      return;
    }

    const selected = lookupMargins?.data?.find((item) => item.id === Number(eventValue));
    setMarginPercentage(selected ? selected : {});
  }, [lookupMargins?.data]);

  useEffect(() => {
    handleSelectMargin(productDetails?.vId);
  }, [productDetails?.vId, handleSelectMargin]);

  // const loadMoreDrugs = async () => {
  //   if (isLoading) return; // Prevent multiple API calls while loading
  //   setIsLoading(true);
  //   try {
  //     const response = await dispatch(fetchDrugList(page)).unwrap(); // Fetch drugs based on current page
  // 
  //     if (response?.data?.drugs?.length > 0) {
  //       setDrugs((prev) => [...prev, ...response?.data?.drugs]); // Append new drugs to the list
  //       setPage((prevPage) => prevPage + 1); // Increment the page number
  //     }
  //   } catch (error) {
  //     console.error("Error fetching drugs:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // Scroll handler
  // const handleScroll = () => {
  //   const container = containerRef.current;
  //   if (
  //     container.scrollHeight - container.scrollTop <=
  //     container.clientHeight + 10
  //   ) {
  //     // Check if user has scrolled to the bottom
  //     loadMoreDrugs();
  //     // setPage((prevPage) => prevPage + 1);
  //   }
  // };

  useEffect(() => {
    if (showNewDrugInput) {
      handleFocus();
    }
  }, [showNewDrugInput]);

  const handleToggleDropdown = (e) => {
    e.preventDefault();
    setIsDropdownOpen((prev) => {
      const newState = !prev;
      if (!newState) return newState; // If closing, no need to focus
      setTimeout(() => {
        const input = document.getElementById("searchDrug");
        input?.focus();
      }, 0);
      return newState;
    });
    setSearchTerm("");
    // setIsDropdownOpen((prev) => !prev);
    setShowNewDrugInput(false);
  };
  const handleAddNewDrug = async (setFieldValue) => {
    const trimmedNewDrug = newDrug.trim();
    if (trimmedNewDrug !== "") {
      let drug = { drugName: trimmedNewDrug };
      const response = await dispatch(
        addDrugs({ drug, selectedDrugs })
      ).unwrap();
      if (response?.status === 201) {
        setFieldValue("drugs", [...selectedDrugs, trimmedNewDrug]);
        setShowNewDrugInput(false);
        setNewDrug("");
        if (selectedDrugs.length >= 4) {
          return;
        } else {
          setSelectedDrugs([...selectedDrugs, trimmedNewDrug]);
        }
      } else {
        setShowNewDrugInput(false);
      }
    }
  };
  const handleRemoveStoreStockChange = (
    e,
    handleChange,
    setFieldTouched,
    setFieldValue,
    values,
    index
  ) => {
    const value = Number(e.target.value);
    const updatedFlags = { ...removeStockFlags };

    if (value > 0) {
      updatedFlags[index] = true;
    } else {
      updatedFlags[index] = false;
    }

    setRemoveStockFlags(updatedFlags);
    setFieldTouched(`storeQty[${index}].removeQty`, true, false);
    setFieldValue(`storeQty[${index}].removeQty`, value);
  };

  const handleRemoveAdminStockChange = (
    e,
    handleChange,
    setFieldTouched,
    setFieldValue,
    values
  ) => {
    const removedQty = Number(e?.target?.value);
    let value = e?.target?.value?.trim();
    if (!isNaN(value)) {
      value = value?.replace(/^0+(?=\d)/, "");
    }
    handleChange({
      target: {
        name: e.target.name,
        value,
      },
    });
    setIsRemoveAdminStockEntered(removedQty > 0); // Enable/disable based on value

    setFieldTouched("removeUnits", true);
    // const updatedQty = values?.productStock - removedQty;
    // setFieldValue("units", updatedQty);
  };

  const handleSelectDrug = (drug, values, setFieldValue, e) => {
    const targetName = (drug?.drugName || "").trim();
    const isAlreadySelected = selectedDrugs.some(
      (d) => (typeof d === "string" ? d : d?.name || d?.drugName || "").trim().toLowerCase() === targetName.toLowerCase()
    );

    if (isAlreadySelected) {
      const updatedSelectedDrugs = selectedDrugs.filter(
        (selectedDrug) => (typeof selectedDrug === "string" ? selectedDrug : selectedDrug?.name || selectedDrug?.drugName || "").trim().toLowerCase() !== targetName.toLowerCase()
      );
      setSelectedDrugs(updatedSelectedDrugs);

      const updatedDrugsField = values.drugs.filter(
        (selectedDrug) => (typeof selectedDrug === "string" ? selectedDrug : selectedDrug?.name || selectedDrug?.drugName || "").trim().toLowerCase() !== targetName.toLowerCase()
      );
      setFieldValue("drugs", updatedDrugsField);
    } else {
      if (selectedDrugs.length >= 4) {
        toast.error("You can only select up to 4 drugs.");
        return;
      }

      setSelectedDrugs((prevSelectedDrugs) => [
        ...prevSelectedDrugs,
        targetName,
      ]);

      setFieldValue("drugs", [...values.drugs, targetName]);
    }
  };

  const handleAddProduct = async (
    values,
    { setFieldTouched, errors, resetForm }
  ) => {
    if (errors?.drugs) {
      setFieldTouched("drugs", true);
    }
    const productValues = { ...values };
    productValues.productName = productValues?.productName?.trim();
    if (Array.isArray(productValues.drugs)) {
      productValues.drugs = [
        ...new Set(
          productValues.drugs
            .map((d) => (typeof d === "string" ? d.trim() : d?.name || d?.drugName || "").trim())
            .filter(Boolean)
        ),
      ];
    }

    let totalUnits = 0;
    if (searchedProduct?.length > 0) {
      productValues.storeQty = productValues?.storeQty?.map((store) => {
        const stock = Number(store?.stock || 0);
        const moreQty = Number(store?.moreQty || 0);
        const removeQty = Number(store?.removeQty || 0);

        let Qty = stock;

        if (moreQty > 0) {
          Qty += moreQty;
        } else if (removeQty > 0) {
          Qty -= removeQty;
        }

        return {
          ...store,
          Qty,
        };
      });

      totalUnits =
        values?.moreUnits > 0
          ? (searchedProduct[0]?.productStock || 0) + (Number(values?.moreUnits) || 0)
          : values?.removeUnits > 0
            ? (searchedProduct[0]?.productStock || 0) - (Number(values?.removeUnits) || 0)
            : (searchedProduct[0]?.productStock || 0);
    } else {
      totalUnits = Number(values?.units || 0);
    }

    productValues.units = totalUnits || 0;
    productValues.units = totalUnits || 0;

    delete productValues.moreUnits;
    delete productValues.productStock;
    delete productValues.removeUnits;

    let response;

    try {
      productValues.storeQty = productValues?.storeQty?.some(
        (store) => store.storeId === "" && store.Qty === 0
      )
        ? []
        : productValues.storeQty.map((store) => {
          const { stock, moreQty, removeQty, Qty, ...rest } = store;
          return {
            ...rest,
            Qty: Qty || 0,
          };
        });

      productValues.tags = selectedTags;
      productValues.tagIds = selectedTags.map((t) => (typeof t === "object" ? t.id : t)).filter(Boolean);
      productValues.images = values?.images !== undefined ? values.images : selectedImages;

      if (searchedProduct?.length > 0) {
        const { productId, ...updatedData } = productValues;
        response = await dispatch(
          modifyProduct({ productId, updatedData })
        ).unwrap();
      } else {
        delete productValues.productId;
        response = await dispatch(addProduct(productValues)).unwrap();
      }
      if (response?.status === 200 || response?.status === 201) {
        setIsRemoveAdminStockEntered(false);
        setIsMoreStockEntered(false);
        setMoreStockFlags({});
        setRemoveStockFlags({});
        if (searchedProduct?.length > 0) {
          setShowEditIcon(false);
          const updatedProduct = response?.data?.product;
          if (updatedProduct) {
            setSelectedProduct(updatedProduct);
            setSelectedDrugs(updatedProduct.drugs || []);
            setSelectedTags(updatedProduct.tags || []);
            setSelectedImages(updatedProduct.images || []);
            setAssignedDrugTags(updatedProduct.drugTags || []);
          }
        } else {
          setSelectedDrugs([]);
          setSelectedTags([]);
          setSelectedImages([]);
          setAssignedDrugTags([]);
          resetForm({
            values: initialValues,
          });
        }
      } else {
        if (productValues.storeQty.length === 0) {
          productValues.storeQty.push({ storeId: "", Qty: 0 });
        }
        if (response?.response?.data?.error)
          toast.error(response?.response?.data?.error);
        handleFocusOnProduct();
      }
    } catch (error) {
      console.error("Complete Error Object:", error);

      if (error.response) {
        console.error("API Error:", error.response.data); // Log the error data from the response
      } else {
        console.error("Unexpected Error:", error);
      }
    }
  };

  const handleEdit = async (
    values,
    resetForm,
    errors,
    setFieldTouched,
    setFieldError,
    validateField,
    validateForm
  ) => {
    if (errors?.drugs || values?.drugs.length === 0) {
      setFieldError("drugs", "At least one drug must be selected");
      setFieldTouched("drugs", true, false);
      await validateField("drugs");
    }
    const validationErrors = await validateForm();
    if (Object.keys(validationErrors)?.length > 0) {
      console.error("Validation Errors:", validationErrors);
      toast.error("Please fix the validation errors before saving.");
      return;
    }

    if (Object.keys(validationErrors)?.length === 0) {
      const productValues = values;
      productValues.productName = productValues?.productName?.trim();

      let totalUnits = 0;

      productValues.storeQty = productValues?.storeQty?.map((store) => {
        const stock = Number(store?.stock || 0);
        const moreQty = Number(store?.moreQty || 0);
        const removeQty = Number(store?.removeQty || 0);

        let Qty = stock;

        if (moreQty > 0) {
          Qty += moreQty;
        } else if (removeQty > 0) {
          Qty -= removeQty;
        }

        return {
          ...store,
          Qty,
        };
      });

      totalUnits =
        values?.moreUnits > 0
          ? (searchedProduct[0]?.productStock || 0) + (Number(values?.moreUnits) || 0)
          : values?.removeUnits > 0
            ? (searchedProduct[0]?.productStock || 0) - (Number(values?.removeUnits) || 0)
            : (searchedProduct[0]?.productStock || 0);

      productValues.units = totalUnits || 0;

      delete productValues.moreUnits;
      delete productValues.productStock;
      delete productValues.removeUnits;

      let response;

      try {
        productValues.storeQty = productValues?.storeQty?.some(
          (store) => store.storeId === "" && store.Qty === 0
        )
          ? []
          : productValues.storeQty.map((store) => {
            const { stock, moreQty, removeQty, Qty, ...rest } = store;
            return {
              ...rest,
              Qty: Qty || 0,
            };
          });

        const { productId, ...updatedData } = productValues;

        response = await dispatch(
          modifyProduct({ productId, updatedData })
        ).unwrap();

        if (response?.status === 200 || response?.status === 201) {
          setIsRemoveAdminStockEntered(false);
          setIsMoreStockEntered(false);
          setMoreStockFlags({});
          setRemoveStockFlags({});
          setShowEditIcon(false);
          const updatedProduct = response?.data?.product;
          if (updatedProduct) {
            setSelectedProduct(updatedProduct);
            setSelectedDrugs(updatedProduct.drugs || []);
            setSelectedTags(updatedProduct.tags || []);
            setAssignedDrugTags(updatedProduct.drugTags || []);
          }
        } else {
          if (productValues.storeQty.length === 0) {
            productValues.storeQty.push({ storeId: "", Qty: 0 });
          }
          if (response?.response?.data?.error)
            toast.error(response?.response?.data?.error);
          handleFocusOnProduct();
        }
      } catch (error) {
        console.error("Complete Error Object:", error);

        if (error.response) {
          console.error("API Error:", error.response.data); // Log the error data from the response
        } else {
          console.error("Unexpected Error:", error);
        }
      }
    }
  };
  const handleFocus = (fieldName) => {
    const inputField = document.querySelector(`[name="${fieldName}"]`);

    if (inputField) {
      inputField.focus();
    }
  };

  const handleFocusOnProduct = () => {
    const inputField = document.getElementById("productName");

    inputField?.focus();
  };
  const handleNewDrug = (e) => {
    e.preventDefault();
    setShowNewDrugInput(true);
    // handleFocus("newDrug");
    const inputField = document.querySelector(`.newDrug`);
    if (inputField) {
      setTimeout(() => {
        inputField?.focus();
      }, 300);
    }
  };
  const handleCancelForm = () => {
    dispatch(setActiveTab({ name: "Stock", index: 0 }));
    const tabChangeEvent = new Event("tabChange");
    window.dispatchEvent(tabChangeEvent);
    dispatch(fetchProducts({ current_page: 1, limit: 10 }));
    dispatch(setSearchProducts([]));
  };

  const handleRemoveProduct = async () => {
    if (searchedProduct?.length > 0) {
      const id = searchedProduct[0]?.id;
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this product?"
      );
      if (confirmDelete) {
        const response = await dispatch(removeProduct(id)).unwrap();
        if (response?.status === 200 || response?.status === 201) {
          setShowEditIcon(false);
          // toast.success("Product successfully deleted.");
        } else {
          // toast.error("Please wait..");
        }
      }
    }
  };

  const onAddNewProductClick = () => {
    setSelectedProduct("");
    setSelectedImages([]);
    dispatch(setSearchProducts([]));
  };
  const filteredDrugs = drugs?.filter((drug) =>
    drug?.drugName?.toLowerCase().includes(searchTerm.toLowerCase())
  );


  const handleClearSearch = (e) => {
    // e.stopPropagation();
    setSearchTerm("");
  };
  const handleEditToggle = (e) => {
    setShowEditIcon(true);
  };
  const handleBlur = (fieldName) => {
    if (editingField === fieldName) {
      setEditingField(null);
    }
  };
  const isDisabled = searchedProduct?.length ? true : false;
  return (
    <section className="bg-gray-100 rounded-[8px]">
      <Loader loading={loading} />
      <div className="bg-white/50 py-3 px-5 rounded-t-[12px] border-b border-primary-100 min-h-[70px] flex items-center">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 w-full">
          <div className="flex flex-1 items-center gap-4 w-full">
            <div className="flex-1 min-w-0">
              <SearchSelectProduct
                selectedProduct={selectedProduct}
                setSelectedProduct={setSelectedProduct}
                activeTabName="Products"
                role={role}
              />
            </div>
            {role === "admin" && (
              <Button
                className="bg-white border-primary-600 border h-[42px] text-primary-700 py-2 px-6 min-w-fit text-[14px] rounded-md flex items-center justify-center gap-3 shadow-sm hover:shadow-md hover:bg-gray-50 transition-all font-semibold shrink-0"
                type="button"
                onClick={onAddNewProductClick}
              >
                <PlusCircle width={20} height={20} className="text-primary-600 flex-shrink-0" />
                <span className="whitespace-nowrap">Add New Product</span>
              </Button>
            )}
          </div>
        </div>
      </div>
      <div className="bg-gray-100 py-4 px-5 rounded-b-[12px]">
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          onSubmit={handleAddProduct}
          validationSchema={
            searchedProduct?.length > 0
              ? updateProductValidation
              : createProductValidation
          }
          validateOnChange={true}
          validateOnBlur={true}
          context={searchedProduct[0] || {}}
        >
          {({
            values,
            setValues,
            resetForm,
            handleChange,
            setFieldValue,
            touched,
            errors,
            setFieldTouched,
            validateField,
            setFieldError,
            validateForm,
          }) => {
            return (
              <Form className="dashboard-container">
                {searchedProduct?.length > 0 && !showEditIcon ? (
                  /* ════════════════════ VIEW MODE ════════════════════ */
                  <div className="bg-white rounded-[12px] border border-primary-100 p-6 shadow-sm mb-4">
                    {/* Top Showcase: Image on Left + Primary Info, Actions & Key Metrics on Right */}
                    <div className="grid grid-cols-12 gap-5 lg:gap-6 pb-6 border-b border-primary-100 mb-6">
                      {/* Left: Product Images Gallery */}
                      <div className="col-span-12 md:col-span-5 lg:col-span-4 xl:col-span-3">
                        <ProductImageGallery
                          images={values?.images?.length ? values.images : (searchedProduct[0]?.images || [])}
                          productName={values?.productName || "Product"}
                          readOnly={true}
                          emptySubtitle="No visual imagery uploaded. Click 'Edit Details' above to add photos."
                          aspectRatio="aspect-square"
                        />
                      </div>

                      {/* Right: Product Identity, Actions & Key Metrics */}
                      <div className="col-span-12 md:col-span-7 lg:col-span-8 xl:col-span-9 flex flex-col justify-between gap-4">
                        {/* Top: Header Info & Action Buttons */}
                        <div>
                          <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3 mb-2.5">
                            {/* Product Title & Status Badges */}
                            <div className="min-w-0 flex-1">
                              <div className="flex items-center gap-2 flex-wrap mb-1.5">
                                <h1 className="text-[20px] sm:text-[22px] font-extrabold text-secondry-800 tracking-tight">
                                  {values?.productName || "Unnamed Product"}
                                </h1>
                                {values?.productId && (
                                  <span className="px-2.5 py-0.5 bg-primary-100 text-primary-800 text-[11px] font-bold font-mono rounded-full border border-primary-200">
                                    ID: #{values?.productId}
                                  </span>
                                )}
                                {values?.type && (
                                  <span className="px-2.5 py-0.5 bg-blue-50 text-blue-700 text-[11px] font-semibold rounded-full border border-blue-200 flex items-center gap-1.5">
                                    <span className="w-1.5 h-1.5 rounded-full bg-blue-500"></span>
                                    {values?.type}
                                  </span>
                                )}
                                <span
                                  className={`px-2.5 py-0.5 text-[11px] font-semibold rounded-full border flex items-center gap-1.5 ${
                                    Number(searchedProduct[0]?.productStock ?? values?.productStock ?? 0) > 0
                                      ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                                      : "bg-rose-50 text-rose-700 border-rose-200"
                                  }`}
                                >
                                  <span
                                    className={`w-1.5 h-1.5 rounded-full ${
                                      Number(searchedProduct[0]?.productStock ?? values?.productStock ?? 0) > 0
                                        ? "bg-emerald-500"
                                        : "bg-rose-500"
                                    }`}
                                  ></span>
                                  Stock: {searchedProduct[0]?.productStock ?? values?.productStock ?? 0}{" "}
                                  {values?.uom ? `(Pack of ${values.uom})` : ""}
                                </span>
                              </div>

                              {/* Manufacturer & Value Table ID */}
                              <div className="text-[12px] sm:text-[13px] text-primary-500 font-medium flex items-center gap-2 flex-wrap">
                                <span>
                                  Manufactured by{" "}
                                  <strong className="text-secondry-700 font-semibold">
                                    {values?.manufacturer || "N/A"}
                                  </strong>
                                </span>
                                {values?.vId ? (
                                  <span className="text-[11px] sm:text-[12px] text-primary-400 flex items-center gap-1">
                                    • Value Table ID:{" "}
                                    <code className="bg-primary-50 px-2 py-0.5 rounded border border-primary-200 text-secondry-600 font-mono font-medium">
                                      {values.vId}
                                    </code>
                                  </span>
                                ) : null}
                              </div>
                            </div>

                            {/* Header Actions */}
                            <div className="flex items-center gap-2 shrink-0 self-start">
                              <Button
                                className="bg-primary-600 hover:bg-primary-700 text-white h-[36px] py-1.5 px-4 text-[12px] sm:text-[13px] font-semibold rounded-full flex items-center gap-2 shadow-xs transition-all cursor-pointer"
                                onClick={(e) => handleEditToggle(e)}
                                type="button"
                              >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
                                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                </svg>
                                Edit Details
                              </Button>
                            </div>
                          </div>
                        </div>

                        {/* Bottom: Key Metrics Grid (MRP, GST, Discount, Units per pack) */}
                        <div className="grid grid-cols-12 gap-3 pt-1">
                          <div className="col-span-6 sm:col-span-3 bg-emerald-50/70 border border-emerald-200/80 rounded-[10px] p-3 sm:p-3.5 flex flex-col justify-between">
                            <span className="text-[10px] sm:text-[11px] font-bold uppercase text-emerald-700 tracking-wider">Maximum Retail Price</span>
                            <div className="mt-2 flex items-baseline gap-1">
                              <span className="text-[20px] sm:text-[22px] font-black text-emerald-900 leading-none">₹{values?.pricing?.mrp || "0"}</span>
                              <span className="text-[10px] text-emerald-600 font-medium">/ pack</span>
                            </div>
                          </div>

                          <div className="col-span-6 sm:col-span-3 bg-blue-50/70 border border-blue-200/80 rounded-[10px] p-3 sm:p-3.5 flex flex-col justify-between">
                            <span className="text-[10px] sm:text-[11px] font-bold uppercase text-blue-700 tracking-wider">GST Rate</span>
                            <div className="mt-2 flex items-baseline gap-1">
                              <span className="text-[20px] sm:text-[22px] font-black text-blue-900 leading-none">{values?.pricing?.gst || "0"}%</span>
                            </div>
                          </div>

                          <div className="col-span-6 sm:col-span-3 bg-amber-50/70 border border-amber-200/80 rounded-[10px] p-3 sm:p-3.5 flex flex-col justify-between">
                            <span className="text-[10px] sm:text-[11px] font-bold uppercase text-amber-700 tracking-wider">Discount</span>
                            <div className="mt-2 flex items-baseline gap-1">
                              <span className="text-[20px] sm:text-[22px] font-black text-amber-900 leading-none">{marginPercentage?.discount ?? values?.discount ?? "0"}%</span>
                            </div>
                          </div>

                          <div className="col-span-6 sm:col-span-3 bg-indigo-50/70 border border-indigo-200/80 rounded-[10px] p-3 sm:p-3.5 flex flex-col justify-between">
                            <span className="text-[10px] sm:text-[11px] font-bold uppercase text-indigo-700 tracking-wider">Units Per Pack (UOM)</span>
                            <div className="mt-2 flex items-baseline gap-1">
                              <span className="text-[20px] sm:text-[22px] font-black text-indigo-900 leading-none">{values?.uom || "1"}</span>
                              <span className="text-[10px] text-indigo-600 font-medium">units</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Main Grid Info */}
                    <div className="grid grid-cols-12 gap-6">
                      {/* Left Column: Classification, Composition & Margins */}
                      <div className="col-span-12 lg:col-span-8 flex flex-col gap-5">
                        {/* Classification & Tags Pill Box */}
                        <div className="bg-primary-50/50 rounded-[12px] p-4 border border-primary-100">
                          <div className="flex items-center justify-between pb-2.5 mb-3 border-b border-primary-200/60">
                            <div className="flex items-center gap-2">
                              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary-600">
                                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                                <line x1="7" y1="7" x2="7.01" y2="7"></line>
                              </svg>
                              <h3 className="text-[12px] font-bold text-secondry-800 uppercase tracking-wider">
                                Tags & Classification
                              </h3>
                            </div>
                          </div>

                          <div className="space-y-3.5">
                            {/* Partition 1: Product Tags */}
                            <div className="bg-white/90 rounded-lg p-3 border border-primary-100 shadow-2xs">
                              <div className="flex items-center justify-between mb-2">
                                <span className="text-[11px] font-bold text-primary-700 uppercase tracking-wider flex items-center gap-1.5">
                                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary-600">
                                    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                                    <line x1="7" y1="7" x2="7.01" y2="7"></line>
                                  </svg>
                                  Product Tags
                                </span>
                                <span className="text-[10px] font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 px-2 py-0.5 rounded-full">
                                  Product Level
                                </span>
                              </div>
                              <div className="flex flex-wrap items-center gap-2">
                                {selectedTags?.length > 0 ? (
                                  selectedTags.map((tag, idx) => {
                                    const tagName = typeof tag === "string" ? tag : tag?.name || tag?.tagName || tag?.tag;
                                    const color = tag?.color || "#10B981";
                                    return (
                                      <span
                                        key={idx}
                                        style={{ backgroundColor: `${color}15`, borderColor: `${color}40`, color: color }}
                                        className="px-2.5 py-1 rounded-md text-[12px] font-semibold border flex items-center gap-1.5 shadow-2xs transition-all"
                                      >
                                        <span style={{ backgroundColor: color }} className="w-2 h-2 rounded-full shrink-0"></span>
                                        {tagName}
                                      </span>
                                    );
                                  })
                                ) : (
                                  <span className="text-[12px] text-primary-400 italic">No product tags assigned</span>
                                )}
                              </div>
                            </div>

                            {/* Partition 2: Drug Tags (View only as editing is from Drugs page) */}
                            <div className="bg-white/90 rounded-lg p-3 border border-indigo-100 shadow-2xs">
                              <div className="flex items-center justify-between mb-1.5">
                                <span className="text-[11px] font-bold text-indigo-700 uppercase tracking-wider flex items-center gap-1.5">
                                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-indigo-600">
                                    <path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"></path>
                                    <path d="m8.5 8.5 7 7"></path>
                                  </svg>
                                  Drug Tags
                                </span>
                                <span className="text-[10px] font-semibold text-indigo-700 bg-indigo-50 border border-indigo-200 px-2 py-0.5 rounded-full flex items-center gap-1">
                                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                                    <circle cx="12" cy="12" r="3"></circle>
                                  </svg>
                                  View only (from Drugs page)
                                </span>
                              </div>
                              <p className="text-[11px] text-primary-400 mb-2">
                                Inherited from assigned drugs. To modify these tags, navigate to the <span className="font-semibold text-indigo-600">Inventory &gt; Drugs</span> page.
                              </p>
                              <div className="flex flex-wrap items-center gap-2">
                                {assignedDrugTags?.length > 0 ? (
                                  assignedDrugTags.map((tag, idx) => {
                                    const tagName = typeof tag === "string" ? tag : tag?.name || tag?.tagName || tag?.tag;
                                    const color = tag?.color || "#6366F1";
                                    const drugSources = tag?.drugs?.length ? tag.drugs : (tag?.fromDrug ? [tag.fromDrug] : []);
                                    return (
                                      <span
                                        key={idx}
                                        style={{ backgroundColor: `${color}15`, borderColor: `${color}40`, color: color }}
                                        className="px-2.5 py-1 rounded-md text-[12px] font-semibold border flex items-center gap-1.5 shadow-2xs transition-all"
                                        title={drugSources.length > 0 ? `Assigned to: ${drugSources.join(", ")}` : "Drug Tag"}
                                      >
                                        <span style={{ backgroundColor: color }} className="w-2 h-2 rounded-full shrink-0"></span>
                                        <span>{tagName}</span>
                                        {drugSources.length > 0 && (
                                          <span className="text-[10px] font-normal px-1.5 py-0.5 rounded bg-white/80 border border-current opacity-80">
                                            {drugSources.length === 1 ? drugSources[0] : `${drugSources.length} drugs`}
                                          </span>
                                        )}
                                      </span>
                                    );
                                  })
                                ) : (
                                  <span className="text-[12px] text-primary-400 italic">
                                    {selectedDrugs?.length > 0
                                      ? "No tags assigned to the selected drugs"
                                      : "No drugs assigned to this product"}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Composition & Active Drugs */}
                        <div className="bg-primary-50/50 rounded-[10px] p-4 border border-primary-100">
                          <h3 className="text-[12px] font-semibold text-primary-500 uppercase tracking-wider mb-2.5">
                            Drug Composition / Active Ingredients
                          </h3>
                          <div className="flex flex-wrap items-center gap-2">
                            {selectedDrugs?.length > 0 ? (
                              selectedDrugs.map((drug, idx) => (
                                <span
                                  key={idx}
                                  className="px-3 py-1 bg-white border border-primary-200 text-secondry-700 text-[12px] font-medium rounded-lg shadow-2xs flex items-center gap-1.5"
                                >
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary-500">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="M12 8v8M8 12h8"></path>
                                  </svg>
                                  {drug}
                                </span>
                              ))
                            ) : (
                              <span className="text-[12px] text-primary-400 italic">No drug formulations specified</span>
                            )}
                          </div>
                        </div>

                        {/* Margin Categories Breakdown */}
                        {marginPercentage && (marginPercentage?.category_a !== undefined || marginPercentage?.category_b !== undefined) && (
                          <div className="bg-primary-50/50 rounded-[10px] p-4 border border-primary-100">
                            <h3 className="text-[12px] font-semibold text-primary-500 uppercase tracking-wider mb-2.5">
                              Category Margins Breakdown
                            </h3>
                            <div className="grid grid-cols-5 gap-2">
                              {["a", "b", "c", "d", "e"].map((cat) => (
                                <div key={cat} className="bg-white p-2.5 rounded-lg border border-primary-100 text-center">
                                  <span className="text-[10px] uppercase font-bold text-primary-400 block mb-1">Cat {cat.toUpperCase()}</span>
                                  <span className="text-[14px] font-bold text-secondry-700">{marginPercentage[`category_${cat}`] ?? 0}%</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Right Column: Store Stock Allocations */}
                      <div className="col-span-12 lg:col-span-4">
                        <div className="bg-primary-50/50 rounded-[10px] p-4 border border-primary-100 h-full flex flex-col">
                          <div className="flex items-center justify-between mb-3">
                            <h3 className="text-[12px] font-semibold text-primary-500 uppercase tracking-wider">
                              Store Allocations
                            </h3>
                            <span className="text-[11px] font-bold text-primary-600 bg-white px-2 py-0.5 rounded border border-primary-200">
                              {productDetails?.storeProducts?.length || 0} Stores
                            </span>
                          </div>

                          <div className="flex-1 overflow-y-auto max-h-[300px] flex flex-col gap-2 pr-1">
                            {productDetails?.storeProducts?.length > 0 ? (
                              productDetails.storeProducts.map((sp, idx) => {
                                const storeInfo = stores.find((s) => s.SID === sp.SID);
                                return (
                                  <div key={idx} className="bg-white p-3 rounded-lg border border-primary-100 flex items-center justify-between shadow-2xs">
                                    <div>
                                      <span className="text-[13px] font-semibold text-secondry-700 block">
                                        {storeInfo?.title || `Store #${sp.SID}`}
                                      </span>
                                      <span className="text-[11px] text-primary-400 font-mono">
                                        ID: #{sp.SID}
                                      </span>
                                    </div>
                                    <div className="text-right">
                                      <span className="text-[14px] font-bold text-emerald-600 block">
                                        {sp.storeStock || 0}
                                      </span>
                                      <span className="text-[10px] text-primary-400 uppercase font-medium">In Stock</span>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="bg-white p-4 rounded-lg border border-dashed border-primary-200 text-center text-[12px] text-primary-400 italic">
                                No store allocations configured
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  /* ════════════════════ EDIT / CREATE MODE ════════════════════ */
                  <div className="bg-white rounded-[12px] border border-primary-100 p-6 shadow-sm mb-4">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-4 mb-6 border-b border-primary-100">
                      <div>
                        <h2 className="text-[18px] font-bold text-secondry-800 flex items-center gap-2">
                          <span>{searchedProduct?.length > 0 ? "Edit Product Details" : "Add New Product"}</span>
                          {values?.productId && (
                            <span className="px-2.5 py-0.5 bg-primary-100 text-primary-800 text-[11px] font-bold font-mono rounded-full border border-primary-200">
                              #{values.productId}
                            </span>
                          )}
                        </h2>
                        <p className="text-[12px] text-primary-400 font-medium mt-0.5">
                          {searchedProduct?.length > 0
                            ? `Modifying information for "${values?.productName || 'selected product'}"`
                            : "Enter the details below to add a new inventory product"}
                        </p>
                      </div>

                      {/* Header Actions for Edit/Add */}
                      <div className="flex items-center gap-2.5 sm:gap-3 flex-wrap">
                        {searchedProduct?.length > 0 ? (
                          <>
                            <Button
                              className="border border-rose-200 bg-rose-50 hover:bg-rose-100 text-rose-700 h-[36px] py-1.5 px-4 text-[12px] sm:text-[13px] font-medium rounded-full flex items-center gap-1.5 transition-all cursor-pointer"
                              type="button"
                              onClick={handleRemoveProduct}
                            >
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0 text-rose-600">
                                <polyline points="3 6 5 6 21 6"></polyline>
                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                              </svg>
                              Delete Product
                            </Button>
                            <Button
                              className="border border-gray-300 hover:bg-gray-50 text-gray-700 h-[36px] py-2 px-5 text-[13px] font-medium rounded-full flex items-center justify-center transition-all cursor-pointer"
                              onClick={() => {
                                resetForm({
                                  values: initialValues,
                                });
                                setShowEditIcon(false);
                                if (searchedProduct[0]?.drugs?.length > 0) {
                                  setSelectedDrugs(productDetails?.drugs);
                                }
                                if (searchedProduct[0]?.tags?.length > 0) {
                                  setSelectedTags(productDetails?.tags);
                                } else {
                                  setSelectedTags([]);
                                }
                                if (searchedProduct[0]?.drugTags?.length > 0) {
                                  setAssignedDrugTags(productDetails?.drugTags);
                                } else {
                                  setAssignedDrugTags([]);
                                }
                              }}
                              type="button"
                            >
                              Cancel
                            </Button>
                            <Button
                              className="bg-primary-600 hover:bg-primary-700 text-white h-[36px] py-2 px-6 text-[13px] font-semibold rounded-full flex items-center justify-center gap-2 shadow-sm transition-all cursor-pointer"
                              type="button"
                              onClick={() =>
                                handleEdit(
                                  values,
                                  resetForm,
                                  errors,
                                  setFieldTouched,
                                  setFieldError,
                                  validateField,
                                  validateForm
                                )
                              }
                            >
                              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
                                <polyline points="20 6 9 17 4 12"></polyline>
                              </svg>
                              Save Details
                            </Button>
                          </>
                        ) : (
                          <>
                            <Button
                              className="border border-gray-300 hover:bg-gray-50 text-gray-700 h-[36px] py-2 px-5 text-[13px] font-medium rounded-full flex items-center justify-center transition-all cursor-pointer"
                              type="button"
                              onClick={() => handleCancelForm()}
                            >
                              Cancel
                            </Button>
                            <Button
                              className="bg-primary-600 hover:bg-primary-700 text-white h-[36px] py-2 px-6 text-[13px] font-semibold rounded-full flex items-center justify-center gap-2 shadow-sm transition-all cursor-pointer"
                              type="submit"
                            >
                              Add Product
                            </Button>
                          </>
                        )}
                      </div>
                    </div>

                    {/* Product Images Section */}
                    <div className="mb-5 bg-white rounded-[12px] p-4 border border-primary-100 shadow-2xs">
                      <div className="flex items-center justify-between mb-3 pb-2 border-b border-primary-100/70">
                        <div className="flex items-center gap-2">
                          <svg className="w-4 h-4 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                          <h2 className="text-[13px] font-bold text-secondry-800 uppercase tracking-wider">
                            Product Images
                          </h2>
                        </div>
                        <span className="text-[11px] text-primary-400 font-medium">
                          Upload packaging, label, or strip photos
                        </span>
                      </div>
                      <ProductImageUploader
                        images={values?.images !== undefined ? values.images : selectedImages}
                        productId={values?.productId}
                        onChange={(newImages) => {
                          setSelectedImages(newImages);
                          setFieldValue("images", newImages);
                        }}
                      />
                    </div>

                    <div className="mb-2">
                      <h2 className="text-black-lose text-[13px] font-medium mb-2">
                        Primary Details
                      </h2>
                      <div className="grid grid-cols-12 gap-[8px]">
                        {values?.productId?.length ? (
                          <div className="col-span-12 md:col-span-6 lg:col-span-4">
                            <Input
                              placeholder="example : 001"
                              inputBox="mb-0"
                              type="text"
                              labelName="Product ID"
                              id="Product_id"
                              name="productId"
                              labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                              className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                              onChange={handleChange}
                              value={values?.productId}
                              disabled
                            />
                          </div>
                        ) : null}
                        <div
                          className={`col-span-12 ${
                            searchedProduct?.length > 0
                              ? "md:col-span-6 lg:col-span-4"
                              : "md:col-span-6"
                          }`}
                        >
                          <Input
                            placeholder="Enter"
                            inputBox="mb-0"
                            type="text"
                            labelName="Product Name*"
                            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                            id="productName"
                            name="productName"
                            value={values?.productName}
                            onChange={(e) => {
                              const trimmedValue = e?.target?.value;
                              setFieldValue("productName", trimmedValue);
                              setFieldTouched("productName", true, false);
                            }}
                            setFieldValue={setFieldValue}
                            isError={
                              touched.productName && Boolean(errors.productName)
                            }
                            errorMessage={errors.productName}
                            onFocus={handleFocusOnProduct}
                            onBlur={() =>
                              handleBlur ? handleBlur("productName") : null
                            }
                            disabledClass="bg-primary-50 border-primary-50 "
                          />
                        </div>
                        {searchedProduct?.length > 0 ? (
                          <>
                            <div className="col-span-12 md:col-span-6 lg:col-span-4">
                              <Input
                                placeholder="Enter"
                                inputBox="mb-0"
                                type="number"
                                labelName="Stock"
                                id="units"
                                name="units"
                                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                className="border-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                value={searchedProduct[0]?.productStock}
                                disabled
                                disabledClass="bg-primary-50 border-primary-50 "
                              />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-4">
                              <Input
                                placeholder="Enter"
                                inputBox="mb-0"
                                type="number"
                                labelName="Add stock*"
                                id="moreUnits"
                                name="moreUnits"
                                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                className="border-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                value={
                                  values?.moreUnits !== undefined
                                    ? values.moreUnits
                                    : ""
                                }
                                onChange={(e) => {
                                  let value = e?.target?.value?.trim();
                                  if (!isNaN(value)) {
                                    value = value?.replace(/^0+(?=\d)/, "");
                                  }
                                  handleChange({
                                    target: {
                                      name: e.target.name,
                                      value,
                                    },
                                  });

                                  setFieldTouched("moreUnits", true);
                                  const moreQty = Number(e.target.value);
                                  const updatedQty = values.productStock + moreQty;

                                  setFieldValue(`units`, updatedQty);
                                  moreQty > 0
                                    ? setIsMoreStockEntered(true)
                                    : setIsMoreStockEntered(false);
                                }}
                                isError={
                                  touched.moreUnits && Boolean(errors.moreUnits)
                                }
                                errorMessage={errors.moreUnits}
                                onBlur={() =>
                                  handleBlur ? handleBlur("moreUnits") : null
                                }
                                disabledClass="bg-primary-50 border-primary-50 "
                              />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-4">
                              <Input
                                placeholder="Enter"
                                inputBox="mb-0"
                                type="number"
                                labelName="Remove stock*"
                                id="removeUnits"
                                name="removeUnits"
                                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                className="border-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                value={
                                  values?.removeUnits !== undefined
                                    ? values.removeUnits
                                    : ""
                                }
                                onChange={(e) =>
                                  handleRemoveAdminStockChange(
                                    e,
                                    handleChange,
                                    setFieldTouched,
                                    setFieldValue,
                                    values
                                  )
                                }
                                isError={
                                  touched.removeUnits && Boolean(errors.removeUnits)
                                }
                                errorMessage={errors.removeUnits}
                                onBlur={(e) => {
                                  handleBlur("removeUnits");
                                  setFieldTouched("removeUnits", true);
                                  const updatedQty =
                                    values?.productStock - e.target.value;
                                  setFieldValue("units", updatedQty);
                                }}
                                disabledClass="bg-primary-50 border-primary-50 "
                              />
                            </div>
                          </>
                        ) : (
                          <div className="col-span-12 md:col-span-6 lg:col-span-3">
                            <Input
                              placeholder="Enter"
                              inputBox="mb-0"
                              type="number"
                              labelName="Stock*"
                              id="units"
                              name="units"
                              labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                              className="border-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                              value={values?.units}
                              onChange={(e) => {
                                let value = e?.target?.value?.trim();
                                if (!isNaN(value)) {
                                  value = value.replace(/^0+(?=\d)/, "");
                                }
                                handleChange({
                                  target: {
                                    name: e.target.name,
                                    value,
                                  },
                                });
                                setFieldTouched("units", true);
                              }}
                              onBlur={() => setFieldTouched("units", true)}
                              isError={touched.units && Boolean(errors.units)}
                              errorMessage={errors.units}
                            />
                          </div>
                        )}
                        <div
                          className={`col-span-12 ${
                            searchedProduct?.length > 0
                              ? "md:col-span-6 lg:col-span-4"
                              : "md:col-span-6 lg:col-span-3"
                          }`}
                        >
                          <Input
                            placeholder="Enter"
                            inputBox="mb-0"
                            type="number"
                            labelName="Units*"
                            id="uom"
                            name="uom"
                            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                            className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                            value={values?.uom}
                            onChange={(e) => {
                              let value = e?.target?.value?.trim();
                              if (!isNaN(value)) {
                                value = value.replace(/^0+(?=\d)/, "");
                              }
                              handleChange({
                                target: {
                                  name: e.target.name,
                                  value,
                                },
                              });
                              setFieldTouched("uom", true);
                            }}
                            isError={touched.uom && Boolean(errors.uom)}
                            errorMessage={errors.uom}
                            disabledClass="bg-primary-50 border-primary-50 "
                            onBlur={() => {
                              setFieldTouched("uom", true);
                              if (handleBlur) {
                                handleBlur("uom");
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {/* Product Type & Manufacturer Row */}
                    <div className="grid grid-cols-12 gap-3 mb-4 items-start">
                      <div className="col-span-12 md:col-span-6">
                        <ProductTypeSelector
                          value={values.type}
                          onChange={(newType) => {
                            setFieldValue("type", newType);
                            setFieldTouched("type", true, false);
                          }}
                          readOnly={false}
                          isError={touched.type && Boolean(errors.type)}
                          errorMessage={errors.type}
                          label="Type*"
                          labelClassName="block text-black-lose text-[13px] font-medium mb-2"
                        />
                      </div>
                      <div className="col-span-12 md:col-span-6">
                        <ManufacturerSelector
                          value={values.manufacturer}
                          onChange={(newManufacturer) => {
                            setFieldValue("manufacturer", newManufacturer);
                            setFieldTouched("manufacturer", true, false);
                          }}
                          onBlur={() => (handleBlur ? handleBlur("manufacturer") : null)}
                          isError={touched.manufacturer && Boolean(errors.manufacturer)}
                          errorMessage={errors.manufacturer}
                          label="Manufacturer*"
                          labelClassName="block text-black-lose text-[13px] font-medium mb-2"
                        />
                      </div>
                    </div>

                    {/* Tags & Classification Section */}
                    <div className="bg-primary-50/50 rounded-[12px] p-4 border border-primary-100 mb-4">
                      <div className="flex items-center justify-between pb-2.5 mb-3 border-b border-primary-200/60">
                        <div className="flex items-center gap-2">
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary-600">
                            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                            <line x1="7" y1="7" x2="7.01" y2="7"></line>
                          </svg>
                          <h3 className="text-[12px] font-bold text-secondry-800 uppercase tracking-wider">
                            Tags & Classification
                          </h3>
                        </div>
                      </div>

                      <div className="grid grid-cols-12 gap-4">
                        {/* Partition 1: Product Tags (Editable) */}
                        <div className="col-span-12 lg:col-span-6 bg-white rounded-lg p-3.5 border border-primary-200/80 shadow-2xs flex flex-col justify-between">
                          <div>
                            <div className="flex items-center justify-between mb-1.5">
                              <span className="text-[11px] font-bold text-primary-700 uppercase tracking-wider flex items-center gap-1.5">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary-600">
                                  <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                                  <line x1="7" y1="7" x2="7.01" y2="7"></line>
                                </svg>
                                Product Tags
                              </span>
                              <span className="text-[10px] font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 px-2 py-0.5 rounded-full flex items-center gap-1">
                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                </svg>
                                Editable
                              </span>
                            </div>
                            <p className="text-[11px] text-primary-400 mb-2.5">
                              Select or add tags applied directly to this product.
                            </p>
                          </div>

                          <ProductTagsSelector
                            selectedTags={selectedTags}
                            onTagsChange={(newTags) => {
                              setSelectedTags(newTags);
                              setFieldValue("tags", newTags);
                            }}
                            readOnly={false}
                            label=""
                          />
                        </div>

                        {/* Partition 2: Drug Tags (View only as editing is from Drugs page) */}
                        <div className="col-span-12 lg:col-span-6 bg-white rounded-lg p-3.5 border border-indigo-100 shadow-2xs flex flex-col justify-between">
                          <div>
                            <div className="flex items-center justify-between mb-1.5">
                              <span className="text-[11px] font-bold text-indigo-700 uppercase tracking-wider flex items-center gap-1.5">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-indigo-600">
                                  <path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"></path>
                                  <path d="m8.5 8.5 7 7"></path>
                                </svg>
                                Drug Tags
                              </span>
                              <span className="text-[10px] font-semibold text-indigo-700 bg-indigo-50 border border-indigo-200 px-2 py-0.5 rounded-full flex items-center gap-1">
                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                  <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                                  <circle cx="12" cy="12" r="3"></circle>
                                </svg>
                                View only (from Drugs page)
                              </span>
                            </div>
                            <p className="text-[11px] text-primary-400 mb-2.5">
                              Inherited from assigned drugs. To modify these tags, navigate to the <span className="font-semibold text-indigo-600">Inventory &gt; Drugs</span> page.
                            </p>
                          </div>

                          <div className="min-h-[42px] p-2 bg-primary-50/40 border border-primary-200 rounded-[8px] flex flex-wrap items-center gap-1.5">
                            {assignedDrugTags?.length > 0 ? (
                              assignedDrugTags.map((tag, idx) => {
                                const tagName = typeof tag === "string" ? tag : tag?.name || tag?.tagName || tag?.tag;
                                const color = tag?.color || "#6366F1";
                                const drugSources = tag?.drugs?.length ? tag.drugs : (tag?.fromDrug ? [tag.fromDrug] : []);
                                return (
                                  <span
                                    key={idx}
                                    style={{ backgroundColor: `${color}15`, borderColor: `${color}40`, color: color }}
                                    className="px-2.5 py-1 rounded-md text-[12px] font-semibold border flex items-center gap-1.5 shadow-2xs transition-all"
                                    title={drugSources.length > 0 ? `Assigned to: ${drugSources.join(", ")}` : "Drug Tag"}
                                  >
                                    <span style={{ backgroundColor: color }} className="w-2 h-2 rounded-full shrink-0"></span>
                                    <span>{tagName}</span>
                                    {drugSources.length > 0 && (
                                      <span className="text-[10px] font-normal px-1.5 py-0.5 rounded bg-white/80 border border-current opacity-80">
                                        {drugSources.length === 1 ? drugSources[0] : `${drugSources.length} drugs`}
                                      </span>
                                    )}
                                  </span>
                                );
                              })
                            ) : (
                              <span className="text-[12px] text-primary-400 italic">
                                {selectedDrugs?.length > 0
                                  ? "No tags assigned to the selected drugs"
                                  : "No drugs assigned to this product"}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <h2 className="text-black-lose text-[13px] font-medium mb-2">
                      Drugs
                    </h2>
                    <div className="mb-3 relative" ref={dropDownRef}>
                      <div
                        className="py-4 px-5 bg-primary-50 border-primary-100 border rounded-[8px] flex items-center justify-between"
                        onClick={(e) => {
                          if (!showEditIcon && isDisabled) {
                            e.preventDefault();
                          } else {
                            handleToggleDropdown(e);
                          }
                        }}
                      >
                        <h3 className="text-[16px] font-medium">
                          {selectedDrugs?.length
                            ? selectedDrugs?.map((drug) => `${drug}`).join(", ")
                            : "No drug selected"}
                        </h3>
                        <img
                          alt="arrow-down"
                          src="./icons/arrow-down.svg"
                          className="w-[24px] h-[24px]"
                        />
                      </div>
                      {isDropdownOpen && (
                        <div className="z-[999] absolute w-full bg-primary-50 mt-1 border-t-none border-b border-x border-primary-100 rounded-xl shadow-lg max-h-60 overflow-y-auto left-0 right-0 ">
                          <div className="relative flex items-center">
                            <input
                              type="text"
                              id="searchDrug"
                              placeholder="Search Drug..."
                              value={searchTerm}
                              onChange={(e) =>
                                setSearchTerm(e?.target?.value.trimStart())
                              }
                              className="w-full p-2 border-b border-gray-300 focus:outline-none rounded-t-md"
                            />
                            {searchTerm && (
                              <button
                                onClick={handleClearSearch}
                                className="absolute right-2 text-gray-500 hover:text-gray-700 focus:outline-none"
                              >
                                <svg
                                  fill="none"
                                  stroke="currentColor"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  viewBox="0 0 24 24"
                                  className="w-4 h-4"
                                >
                                  <path d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                              </button>
                            )}
                          </div>
                          {showNewDrugInput && (
                            <div className="bg-primary-50 flex items-center relative">
                              <input
                                type="text"
                                value={newDrug}
                                id="newDrug"
                                name="drugs"
                                onChange={(e) => setNewDrug(e.target.value)}
                                placeholder="Enter new drug name"
                                className="py-4 pl-4 border-x-none border-y newDrug bg-primary-50 border-primary-100 h-[56px] rounded-none w-full focus:outline-none pr-[40px]"
                                isError={touched.drugs && Boolean(errors.drugs)}
                                errorMessage={errors.drugs}
                                onFocus={handleFocus}
                                ref={inputRef}
                              />
                              <button
                                onClick={() => handleAddNewDrug(setFieldValue)}
                                type="button"
                                className="absolute top-3 right-2 p-2 hover:bg-red-500/25 rounded-full"
                              >
                                <Plus />
                              </button>
                            </div>
                          )}

                          <ul className="bg-primary-50">
                            {!showNewDrugInput && (
                              <div className="bg-primary-50 flex items-center relative">
                                <li
                                  className="p-4 cursor-pointer text-grey-500 hover:bg-gray-100 w-full"
                                  // onClick={handleNewDrug}
                                  data-ignore-outside-click
                                  onClick={(e) => {
                                    if (isDisabled && !showEditIcon) {
                                      return;
                                    } else {
                                      handleNewDrug(e);
                                    }
                                  }}
                                >
                                  Enter New
                                </li>
                                <button
                                  onClick={() => handleAddNewDrug(setFieldValue)}
                                  type="button"
                                  className="absolute top-3 right-2 p-2 hover:bg-red-500/25 rounded-full"
                                >
                                  <Plus />
                                </button>
                              </div>
                            )}

                            {filteredDrugs?.length > 0 ? (
                              filteredDrugs?.map((drug, index) => (
                                <>
                                  <li
                                    key={drug?.id}
                                    className="p-1 flex items-center cursor-pointer hover:bg-gray-100 rounded-md transition-colors"
                                  >
                                    <div
                                      className="flex items-center gap-3 w-full"
                                      onClick={(e) =>
                                        isDisabled && !showEditIcon
                                          ? undefined
                                          : handleSelectDrug(
                                            drug,
                                            values,
                                            setFieldValue,
                                            e
                                          )
                                      }
                                    >
                                      {/* Checkbox for selecting drugs */}
                                      <div
                                        htmlFor={`product-check-${drug?.id}`}
                                        className="p-3 cus-checkbox"
                                      >
                                        <input
                                          type="checkbox"
                                          id={`product-check-${drug?.id}`}
                                          checked={selectedDrugs.some(
                                            (d) =>
                                              (typeof d === "string" ? d : d?.name || d?.drugName || "")
                                                .trim()
                                                .toLowerCase() === (drug?.drugName || "").trim().toLowerCase()
                                          )}
                                          onChange={(e) =>
                                            handleSelectDrug(
                                              drug,
                                              values,
                                              setFieldValue,
                                              e
                                            )
                                          }
                                          className="h-[20px] w-[20px]"
                                        />
                                        <span></span>
                                      </div>
                                      {/* Drug name */}
                                      <div className="text-sm text-gray-700 flex-grow select-none">
                                        {drug?.drugName}&nbsp;
                                      </div>
                                    </div>
                                  </li>
                                  {index === filteredDrugs?.length - 1 && (
                                    <li
                                      ref={loaderRef}
                                      className="loader-item"
                                      style={{
                                        height: "1px",
                                        visibility: "hidden",
                                      }}
                                    >
                                      {isLoading && <span>Loading...</span>}
                                    </li>
                                  )}
                                </>
                              ))
                            ) : (
                              <li className="p-4 text-gray-500">No Drugs found</li>
                            )}
                          </ul>
                        </div>
                      )}

                      {touched.drugs && errors.drugs && (
                        <div className="text-orange-800 text-[11px] uppercase mt-1 font-medium">
                          {errors.drugs}
                        </div>
                      )}
                    </div>
                    <div className="mb-2">
                      <h2 className="text-black-lose text-[13px] font-medium mb-2">
                        Store Stock
                      </h2>
                      <FieldArray
                        name="storeQty"
                        render={({ push, remove }) => (
                          <div className="relative">
                            {values?.storeQty?.map((store, index) => (
                              <div
                                className="grid grid-cols-3 sm:grid-cols-6 lg:grid-cols-12 gap-[8px] pr-[86px] relative mb-2"
                                key={index}
                              >
                                <div
                                  className={`${searchedProduct?.length > 0
                                      ? "col-span-3"
                                      : "col-span-6"
                                    }`}
                                >
                                  <ProductStoreSelector
                                    value={store?.storeId}
                                    stores={stores}
                                    selectedStoreIds={values.storeQty?.map((item) => item.storeId) || []}
                                    readOnly={searchedProduct?.length > 0 && Boolean(store?.storeId)}
                                    onChange={(newStoreId) => {
                                      setFieldValue(`storeQty[${index}].storeId`, newStoreId);
                                      setFieldTouched(`storeQty[${index}].storeId`, true, false);
                                    }}
                                    isError={
                                      touched.storeQty?.[index]?.storeId &&
                                      Boolean(errors.storeQty?.[index]?.storeId)
                                    }
                                    errorMessage={errors.storeQty?.[index]?.storeId}
                                    label={null}
                                  />
                                </div>
                                {searchedProduct?.length > 0 ? (
                                  <>
                                    <div className="col-span-3">
                                      <Input
                                        placeholder="Stock"
                                        labelName="Stock"
                                        type="number"
                                        value={store.stock}
                                        labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                        className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                        disabled
                                        disabledClass="bg-primary-50 border-primary-50 "
                                      />
                                    </div>
                                    <div className="col-span-3">
                                      <Input
                                        labelName="Add stock"
                                        placeholder="enter"
                                        type="number"
                                        name={`storeQty[${index}].moreQty`}
                                        labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                        className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                        value={store.moreQty}
                                        onChange={(e) => {
                                          let value = e?.target?.value?.trim();
                                          if (!isNaN(value)) {
                                            value = value?.replace(/^0+(?=\d)/, "");
                                          }
                                          handleChange({
                                            target: {
                                              name: e.target.name,
                                              value,
                                            },
                                          });
                                          const updatedFlags = {
                                            ...moreStockFlags,
                                          };
                                          if (value > 0) {
                                            updatedFlags[index] = true;
                                          } else {
                                            updatedFlags[index] = false;
                                          }
                                          const moreQty = Number(e.target.value);

                                          if (moreQty > values.units) {
                                            setFieldError(
                                              `storeQty[${index}].moreQty`,
                                              "Quantity cannot exceed units"
                                            );
                                          } else {
                                            setFieldError(
                                              `storeQty[${index}].moreQty`,
                                              ""
                                            );
                                          }
                                          setMoreStockFlags(updatedFlags);
                                          setFieldValue(
                                            `storeQty[${index}].moreQty`,
                                            moreQty
                                          );
                                          setFieldTouched(
                                            `storeQty[${index}].moreQty`,
                                            true,
                                            false
                                          );
                                        }}
                                        isError={
                                          touched.storeQty?.[index]?.moreQty &&
                                          Boolean(errors.storeQty?.[index]?.moreQty)
                                        }
                                        errorMessage={
                                          errors.storeQty?.[index]?.moreQty
                                        }

                                        onBlur={() => {
                                          handleBlur(`storeQty[${index}].moreQty`);
                                          setFieldTouched(
                                            `storeQty[${index}].moreQty`,
                                            true
                                          );
                                        }}

                                        disabledClass="bg-primary-50 border-primary-50 "
                                      />
                                    </div>
                                    <div className="col-span-3">
                                      <Input
                                        labelName="Remove stock"
                                        placeholder="enter"
                                        type="number"
                                        name={`storeQty[${index}].removeQty`}
                                        labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                        className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                        value={store.removeQty}
                                        // onBlur={() =>
                                        //   setFieldTouched(
                                        //     `storeQty[${index}].removeQty`,
                                        //     true
                                        //   )
                                        // }
                                        // disabled={moreStockFlags[index]}
                                        onChange={(e) =>
                                          handleRemoveStoreStockChange(
                                            e,
                                            handleChange,
                                            setFieldTouched,
                                            setFieldValue,
                                            values,
                                            index
                                          )
                                        }
                                        isError={
                                          touched.storeQty?.[index]?.removeQty &&
                                          Boolean(
                                            errors.storeQty?.[index]?.removeQty
                                          )
                                        }
                                        errorMessage={
                                          errors.storeQty?.[index]?.removeQty
                                        }
                                        onBlur={() => {
                                          handleBlur(
                                            `storeQty[${index}].removeQty`
                                          );
                                          setFieldTouched(
                                            `storeQty[${index}].removeQty`,
                                            true
                                          );
                                        }}

                                        disabledClass="bg-primary-50 border-primary-50 "
                                      />
                                    </div>
                                    {/* <div className="col-span-3">
                                  <Input
                                    labelName="Remove stock"
                                    placeholder="enter"
                                    type="number"
                                    name={`storeQty[${index}].removeQty`}
                                    labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                    className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                    value={store.moreQty}
                                    onChange={(e) => {
                                      let value = e?.target?.value?.trim();
                                      if (!isNaN(value)) {
                                        value = value?.replace(/^0+(?=\d)/, "");
                                      }
                                      handleChange({
                                        target: {
                                          name: e.target.name,
                                          value,
                                        },
                                      });
                                      const moreQty = Number(e.target.value);

                                      if (moreQty > values.units) {
                                        setFieldError(
                                          `storeQty[${index}].moreQty`,
                                          "Quantity cannot exceed units"
                                        );
                                      } else {
                                        setFieldError(
                                          `storeQty[${index}].moreQty`,
                                          ""
                                        );
                                      }

                                      setFieldValue(
                                        `storeQty[${index}].moreQty`,
                                        moreQty
                                      );
                                      setFieldTouched(
                                        `storeQty[${index}].moreQty`,
                                        true,
                                        false
                                      );
                                    }}
                                    isError={
                                      touched.storeQty?.[index]?.moreQty &&
                                      Boolean(errors.storeQty?.[index]?.moreQty)
                                    }
                                    errorMessage={
                                      errors.storeQty?.[index]?.moreQty
                                    }
                                  />
                                </div> */}
                                  </>
                                ) : (
                                  <div className="col-span-6">
                                    <div
                                      className={`${Boolean(errors.storeQty?.[index]?.Qty)
                                          ? "pb-[20px] "
                                          : ""
                                        }relative`}
                                    >
                                      <Input
                                        placeholder="Qty"
                                        inputBox="mb-0"
                                        inputMain="mb-0"
                                        type="number"
                                        labelName="Qty"
                                        id={`store_qty_${index}`}
                                        name={`storeQty[${index}].Qty`}
                                        labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                        className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                        value={store.Qty}
                                        onChange={(e) => {
                                          const value = Number(e.target.value);

                                          const units = values.units;

                                          if (value > units) {
                                            setFieldError(
                                              `storeQty[${index}].Qty`,
                                              "Quantity cannot exceed units"
                                            );
                                          } else {
                                            setFieldError(
                                              `storeQty[${index}].Qty`,
                                              ""
                                            );
                                          }

                                          handleChange(e);
                                          setFieldTouched(
                                            `storeQty[${index}].Qty`,
                                            true
                                          );
                                        }}
                                        isError={
                                          touched.storeQty?.[index]?.Qty &&
                                          Boolean(errors.storeQty?.[index]?.Qty)
                                        }
                                        errorMessage={errors.storeQty?.[index]?.Qty}
                                      />

                                      {/* {errors.storeQty &&
                                    typeof errors.storeQty === "string" && (
                                      <div className="text-orange-800 ">
                                        {errors.storeQty}
                                      </div>
                                    )} */}
                                    </div>
                                  </div>
                                )}

                                <div className="absolute right-0 top-[11px] flex items-center gap-1.5">
                                  {/* Add Store Button */}
                                  <button
                                    type="button"
                                    onClick={() =>
                                      push({
                                        storeId: "",
                                        Qty: 0,
                                        moreQty: 0,
                                        stock: 0,
                                      })
                                    }
                                    title="Add store allocation"
                                    aria-label="Add store allocation"
                                    className="w-[32px] h-[32px] rounded-lg bg-emerald-50 hover:bg-emerald-100 active:scale-95 border border-emerald-200/90 hover:border-emerald-300 text-emerald-700 hover:text-emerald-800 flex items-center justify-center transition-all duration-200 shadow-2xs group cursor-pointer"
                                  >
                                    <Plus
                                      width={15}
                                      height={15}
                                      fill="currentColor"
                                      className="transition-transform group-hover:scale-110"
                                    />
                                  </button>

                                  {/* Delete Store Button */}
                                  {searchedProduct?.length > 0 ? (
                                    values?.storeQty?.length > 0 && (
                                      <button
                                        type="button"
                                        onClick={() => {
                                          if (
                                            Number(store.stock) === 0 ||
                                            Number(store.Qty) === 0
                                          ) {
                                            const confirmDelete = window.confirm(
                                              "Are you sure you want to remove this store?"
                                            );
                                            if (confirmDelete) {
                                              remove(index);
                                            }
                                          } else {
                                            toast.error(
                                              "This store has stock available. Please clear the stock before removing."
                                            );
                                          }
                                        }}
                                        title="Remove store allocation"
                                        aria-label="Remove store allocation"
                                        className="w-[32px] h-[32px] rounded-lg bg-rose-50 hover:bg-rose-100 active:scale-95 border border-rose-200/90 hover:border-rose-300 text-rose-600 hover:text-rose-700 flex items-center justify-center transition-all duration-200 shadow-2xs group cursor-pointer"
                                      >
                                        <Delete
                                          width={15}
                                          height={15}
                                          fill="currentColor"
                                          className="transition-transform group-hover:scale-110"
                                        />
                                      </button>
                                    )
                                  ) : (
                                    values?.storeQty?.length > 1 && (
                                      <button
                                        type="button"
                                        onClick={() => {
                                          const confirmDelete = window.confirm(
                                            "Are you sure you want to remove this store?"
                                          );
                                          if (confirmDelete) {
                                            remove(index);
                                          }
                                        }}
                                        title="Remove store allocation"
                                        aria-label="Remove store allocation"
                                        className="w-[32px] h-[32px] rounded-lg bg-rose-50 hover:bg-rose-100 active:scale-95 border border-rose-200/90 hover:border-rose-300 text-rose-600 hover:text-rose-700 flex items-center justify-center transition-all duration-200 shadow-2xs group cursor-pointer"
                                      >
                                        <Delete
                                          width={15}
                                          height={15}
                                          fill="currentColor"
                                          className="transition-transform group-hover:scale-110"
                                        />
                                      </button>
                                    )
                                  )}
                                </div>
                              </div>
                            ))}
                            {(!values?.storeQty || values.storeQty.length === 0) && (
                              <div className="py-4 px-3 border border-dashed border-primary-200 rounded-lg text-center bg-primary-50/40 mb-2">
                                <p className="text-[12px] text-gray-500 mb-2">No stores allocated yet.</p>
                                <button
                                  type="button"
                                  onClick={() =>
                                    push({
                                      storeId: "",
                                      Qty: 0,
                                      moreQty: 0,
                                      stock: 0,
                                    })
                                  }
                                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-emerald-50 hover:bg-emerald-100 border border-emerald-200 text-emerald-700 text-[12px] font-semibold transition-all cursor-pointer shadow-2xs"
                                >
                                  <Plus width={14} height={14} fill="currentColor" />
                                  <span>Add Store Allocation</span>
                                </button>
                              </div>
                            )}
                            {errors.storeQty &&
                              typeof errors?.storeQty === "string" && (
                                <div className="bg-red-600 text-white border-orange-500 p-1.5 rounded-[5px]">
                                  {errors?.storeQty}
                                </div>
                              )}
                          </div>
                        )}
                      />
                    </div>

                    <div className="mb-4">
                      <h2 className="text-black-lose text-[13px] font-medium mb-2">
                        V Table
                      </h2>
                      <div className="grid grid-cols-12 gap-3 items-start">
                        <div className="col-span-12 md:col-span-6 lg:col-span-4">
                          <ProductVTableSelector
                            value={values.vId}
                            lookupMargins={lookupMargins}
                            readOnly={false}
                            onChange={(newVId) => {
                              handleSelectMargin(newVId);
                              setFieldValue("vId", newVId);
                              setFieldTouched("vId", true, false);
                            }}
                            isError={touched.vId && Boolean(errors.vId)}
                            errorMessage={errors.vId}
                            label={null}
                          />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-2">
                          <Input
                            inputBox="mb-0"
                            type="number"
                            labelName="discount*"
                            id="discount"
                            step="any"
                            name="marginPercentage.discount"
                            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                            className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                            value={marginPercentage?.discount ?? ""}
                            disabled
                            disabledClass="bg-primary-50 border-primary-50 "
                          />
                        </div>
                        <div className="col-span-12 lg:col-span-6 grid grid-cols-5 gap-2">
                          <Input
                            inputBox="mb-0"
                            type="number"
                            labelName="A*"
                            id="am"
                            step="any"
                            name="marginPercentage.category_a"
                            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                            className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                            value={marginPercentage?.category_a ?? ""}
                            disabled
                            disabledClass="bg-primary-50 border-primary-50 "
                          />
                          <Input
                            inputBox="mb-0"
                            type="number"
                            labelName="B*"
                            id="bm"
                            name="marginPercentage.category_b"
                            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                            className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                            value={marginPercentage?.category_b ?? ""}
                            disabled
                            disabledClass="bg-primary-50 border-primary-50 "
                          />
                          <Input
                            inputBox="mb-0"
                            type="number"
                            labelName="C*"
                            id="cm"
                            step="any"
                            name="marginPercentage.category_c"
                            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                            className="border-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                            value={marginPercentage?.category_c ?? ""}
                            disabled
                            disabledClass="bg-primary-50 border-primary-50 "
                          />
                          <Input
                            inputBox="mb-0"
                            type="number"
                            labelName="D*"
                            id="dm"
                            step="any"
                            name="marginPercentage.category_d"
                            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                            className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                            value={marginPercentage?.category_d ?? ""}
                            disabled
                            disabledClass="bg-primary-50 border-primary-50 "
                          />
                          <Input
                            inputBox="mb-0"
                            type="number"
                            labelName="E*"
                            id="em"
                            step="any"
                            name="marginPercentage.category_e"
                            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                            className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                            value={marginPercentage?.category_e ?? ""}
                            disabled
                            disabledClass="bg-primary-50 border-primary-50 "
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <h2 className="text-black-lose text-[13px] font-medium mb-2">
                        Pricing
                      </h2>
                      <div className="grid grid-cols-12 gap-[8px]">
                        <div className="col-span-12 md:col-span-6">
                          <Input
                            placeholder="Enter"
                            inputBox="mb-0"
                            type="number"
                            labelName="MRP*"
                            id="mrp"
                            step="any"
                            name="pricing.mrp"
                            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                            className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                            value={values?.pricing?.mrp}
                            isError={
                              touched.pricing?.mrp && Boolean(errors.pricing?.mrp)
                            }
                            errorMessage={errors.pricing?.mrp}
                            onChange={(e) => {
                              handleChange(e);
                              setFieldTouched("pricing.mrp", true, false);
                            }}
                            onBlur={() => {
                              handleBlur("pricing.mrp");
                              setFieldTouched("pricing.mrp", true);
                            }}
                            disabledClass="bg-primary-50 border-primary-50 "
                          />
                        </div>
                        <div className="col-span-12 md:col-span-6">
                          <Input
                            placeholder="Enter"
                            inputBox="mb-0"
                            type="number"
                            labelName="GST%*"
                            id="gst"
                            name="pricing.gst"
                            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                            className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                            value={values?.pricing?.gst}
                            onChange={(e) => {
                              handleChange(e);
                              setFieldTouched("pricing.gst", true, false);
                            }}
                            isError={
                              touched.pricing?.gst && Boolean(errors.pricing?.gst)
                            }
                            errorMessage={errors.pricing?.gst}
                            onBlur={() => {
                              handleBlur("pricing.gst");
                              setFieldTouched("pricing.gst", true);
                            }}
                            disabledClass="bg-primary-50 border-primary-50 "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Form>
            );
          }}
        </Formik>
      </div>
    </section>
  );
}

export default Products;
